import React from 'react';
import Main from './Components/JSX/Main';
function App() {
  return (
    <div>
      <Main/>
    </div>

  );
}

export default App;